import React from 'react';

const STYLE_DISABLED = {
    pointerEvents: 'none',
};

function preventDefault(e) {
    e.preventDefault();
}

const BreadcrumbItem = props => {
    const hasLink = props.link && props.link !== '#';

    return (
        <div>
            {props.index > 0 && (
                <div className="breadcrumb__item item__arrow">&nbsp;&nbsp;{'>'}&nbsp;&nbsp;</div>
            )}
            <div className="breadcrumb__item">
                <a
                    style={hasLink ? undefined : STYLE_DISABLED}
                    href={hasLink ? props.link : '#'}
                    onClick={
                        !hasLink
                            ? preventDefault
                            : hasLink && props.historyState
                              ? e => {
                                    e.preventDefault();
                                    if (props.historyState === 'goBack') {
                                        history.back();
                                    } else {
                                        props.history.push({
                                            pathname: props.link,
                                            state: props.historyState,
                                        });
                                    }
                                }
                              : undefined
                    }>
                    {props.title}
                </a>
            </div>
        </div>
    );
};

export default BreadcrumbItem;
